module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Hire from your socials"}}')
  delete Component.options._Ctor
}
